import HeroSection from "./components/HeroSection";
import CategoriesSection from "./components/CategoriesSection";
import TrendingSection from "./components/TrendingSection";
import SuccessStoriesSection from "./components/SuccessStoriesSection";
import StartupsSection from "./components/StartupsSection";
import InnovationsSection from "./components/InnovationsSection";
import FemmesSection from "./components/FemmesSection";
import JeunesTalentsSection from "./components/JeunesTalentsSection";
import DiasporaSection from "./components/DiasporaSection";
import InterviewsSection from "./components/InterviewsSection";
import OpportunitesSection from "./components/OpportunitesSection";
import FormationsSection from "./components/FormationsSection";
import SubmitAndNewsletterSection from "./components/SubmitAndNewsletterSection";
import { useSeoMeta } from "@/hooks/useSeoMeta";
import { useJsonLd } from "@/hooks/useJsonLd";

export default function HomePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || "https://example.com";

  useSeoMeta({
    title: "Wazi Stories Afrique — Histoires d'entrepreneurs africains qui inspirent",
    description: "Découvrez les success stories, startups, innovations et portraits d'entrepreneurs africains qui transforment le continent. Inspirez-vous des meilleurs talents d'Afrique.",
    image: "https://public.readdy.ai/ai/img_res/447714ac0d897b672e89d7cdd686ae15.jpg",
    type: "website",
    keywords: "entrepreneur africain, startup Afrique, success story Afrique, innovation africaine, Wazi Stories",
  });

  useJsonLd({
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebSite",
        "@id": `${siteUrl}/#website`,
        "url": siteUrl,
        "name": "Wazi Stories Afrique",
        "description": "Histoires d'entrepreneurs africains qui inspirent",
        "inLanguage": "fr-FR",
        "potentialAction": {
          "@type": "SearchAction",
          "target": {
            "@type": "EntryPoint",
            "urlTemplate": `${siteUrl}/recherche?q={search_term_string}`
          },
          "query-input": "required name=search_term_string"
        }
      },
      {
        "@type": "Organization",
        "@id": `${siteUrl}/#organization`,
        "name": "Wazi Stories Afrique",
        "url": siteUrl,
        "logo": {
          "@type": "ImageObject",
          "url": `${siteUrl}/vite.svg`
        },
        "sameAs": [
          "https://twitter.com/WaziStoriesAfrique"
        ],
        "contactPoint": {
          "@type": "ContactPoint",
          "email": "contact@waziconsulting.com",
          "contactType": "customer support",
          "availableLanguage": ["French", "English"]
        }
      }
    ]
  }, "home");

  return (
    <main>
      <HeroSection />
      <CategoriesSection />
      {/* Section "À la une" — articles récents 2024-2025 en priorité */}
      <TrendingSection />
      <SuccessStoriesSection />
      <StartupsSection />
      <FemmesSection />
      <JeunesTalentsSection />
      <InnovationsSection />
      <InterviewsSection />
      <DiasporaSection />
      <OpportunitesSection />
      <FormationsSection />
      <SubmitAndNewsletterSection />
    </main>
  );
}
